import { ReportStatusEnum } from '../../types/enums/affected-staff/report-status.enum'
import { StaffPaymentStatusEnum } from '../../types/enums/affected-staff/staff-payment-status.enum'
import { AccomodationCategoryEnum } from '../../types/enums/product/accomodation-category.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { AffectedStaffSalaryFilter } from '../../types/models/affectedStaff/affected-staff'

export const transformAffectedStaffSalaryFiltersToUrl = (
  filters?: AffectedStaffSalaryFilter
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length > 0)
    searchParams.set('countries', filters.countries.join(','))
  if (filters.periods && filters.periods.length > 0)
    searchParams.set('periods', filters.periods.join(','))
  if (filters.formulas && filters.formulas.length > 0)
    searchParams.set('formulas', filters.formulas.join(','))
  if (filters.qualifications && filters.qualifications.length > 0)
    searchParams.set('qualifications', filters.qualifications.join(','))
  if (filters.positions && filters.positions.length > 0)
    searchParams.set('positions', filters.positions.join(','))
  if (filters.paymentStatuses && filters.paymentStatuses.length > 0)
    searchParams.set('paymentStatuses', filters.paymentStatuses.join(','))
  if (filters.pasCompleted) searchParams.set('pasCompleted', filters.pasCompleted.toString())
  if (filters.endOfStayReportStatus && filters.endOfStayReportStatus.length > 0)
    searchParams.set('endOfStayReportStatus', filters.endOfStayReportStatus.join(','))
  if (filters.departureDateFrom) searchParams.set('departureDateFrom', filters.departureDateFrom)
  if (filters.departureDateTo) searchParams.set('departureDateTo', filters.departureDateTo)
  if (filters.arrivalDateFrom) searchParams.set('arrivalDateFrom', filters.arrivalDateFrom)
  if (filters.arrivalDateTo) searchParams.set('arrivalDateTo', filters.arrivalDateTo)
  if (filters.affectedAtFrom) searchParams.set('affectedAtFrom', filters.affectedAtFrom)
  if (filters.affectedAtTo) searchParams.set('affectedAtTo', filters.affectedAtTo)
  if (filters.trips && filters.trips.length > 0) searchParams.set('trips', filters.trips.join(','))
  if (filters.accomodations && filters.accomodations.length > 0)
    searchParams.set('accomodations', filters.accomodations.join(','))

  return searchParams.toString()
}

export const transformUrlToAffectedStaffSalaryFilters = (
  searchParams: URLSearchParams
): AffectedStaffSalaryFilter => {
  const filters: AffectedStaffSalaryFilter = {}

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',')
  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',').map(Number)
  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',').map(Number)
  const qualifications = searchParams.get('qualifications')
  if (qualifications)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]
  const positions = searchParams.get('positions')
  if (positions) filters.positions = positions.split(',') as StaffPositionEnum[]
  const paymentStatuses = searchParams.get('paymentStatuses')
  if (paymentStatuses)
    filters.paymentStatuses = paymentStatuses.split(',') as StaffPaymentStatusEnum[]
  const pasCompleted = searchParams.get('pasCompleted')
  if (pasCompleted) filters.pasCompleted = pasCompleted === 'true'
  const endOfStayReportStatus = searchParams.get('endOfStayReportStatus')
  if (endOfStayReportStatus)
    filters.endOfStayReportStatus = endOfStayReportStatus.split(',') as ReportStatusEnum[]
  const departureDateFrom = searchParams.get('departureDateFrom')
  if (departureDateFrom) filters.departureDateFrom = departureDateFrom
  const departureDateTo = searchParams.get('departureDateTo')
  if (departureDateTo) filters.departureDateTo = departureDateTo
  const arrivalDateFrom = searchParams.get('arrivalDateFrom')
  if (arrivalDateFrom) filters.arrivalDateFrom = arrivalDateFrom
  const arrivalDateTo = searchParams.get('arrivalDateTo')
  if (arrivalDateTo) filters.arrivalDateTo = arrivalDateTo
  const affectedAtFrom = searchParams.get('affectedAtFrom')
  if (affectedAtFrom) filters.affectedAtFrom = affectedAtFrom
  const affectedAtTo = searchParams.get('affectedAtTo')
  if (affectedAtTo) filters.affectedAtTo = affectedAtTo
  const trips = searchParams.get('trips')
  if (trips) filters.trips = trips.split(',').map(Number)
  const accomodations = searchParams.get('accomodations')
  if (accomodations) filters.accomodations = accomodations.split(',') as AccomodationCategoryEnum[]

  return filters
}
